import { useEffect } from 'react'
import { useLocation } from '@tanstack/react-router'
import { getLocaleDir, getLocaleFromPath } from '@/lib/i18n-utils'

// SEO tags are server-rendered by route head() functions. This hook only keeps
// <html lang/dir> in sync after client-side navigation between locales.
export function useI18nMeta() {
  const { pathname } = useLocation()
  useEffect(() => {
    const locale = getLocaleFromPath(pathname)
    document.documentElement.lang = locale
    document.documentElement.dir = getLocaleDir(locale)
    document.querySelectorAll('script[data-seo-id]').forEach((n) => n.remove())
  }, [pathname])
}
